<template>
    <b-tab :title="tabTitle(index)" active class="pt-3">
        <div v-if="index === 5">
            <p class="h5">
                Si votre associé contribue à plus de 5 apports en nature, vous serez contacté(e) par Assistel à la suite de votre souscription.
            </p>
        </div>

        <div v-else>
            <b-form-row>
                <b-col cols="12" sm="6">
                    <b-form-group
                    label="Nature de l'apport"
                    label-for="contribution-nature"
                    invalid-feedback="La nature de l'apport est obligatoire.">
                        <b-input
                        id="contribution-nature"
                        v-model.trim="$v.inKindContribution.$model"
                        :state="validateState($v.inKindContribution)" />
                    </b-form-group>
                </b-col>
            </b-form-row>
        </div>

        <b-form-row class="mt-3">
            <b-col cols="auto" v-if="index != 5">
                <b-button class="btn" @click="addInKindContribution">
                    Ajouter un nouvel apport en nature
                </b-button>
            </b-col>

            <b-col v-if="index !== 0">
                <b-button class="btn btn-danger" @click="deleteInKindContribution(index)">
                    Supprimer l'apport en nature
                </b-button>
            </b-col>
        </b-form-row>
    </b-tab>
</template>

<script>
    import { required } from "vuelidate/lib/validators";

    export default {
        props : {
            index : {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                inKindContribution : null
            }
        },
        validations() {
            return {
                inKindContribution : { required }
            }
        },
        watch: {
            $v: {
                handler: function(val) {
                    this.$emit('update-in-kind-contribution', this.index, this.inKindContribution);

                    if (!val.$invalid) {
                        this.$emit('can-continue', true);
                    } else {
                        this.$emit('can-continue', false);
                    }
                },
                deep: true
            }
        },
        methods: {
            addInKindContribution() {
                this.$emit('add-in-kind-contribution');
            },
            deleteInKindContribution(index) {
                this.$emit('delete-in-kind-contribution', index);
            },
            tabTitle(index) {
                if (index === 5) {
                    return "+5";
                } else {
                    index ++;
                    const title = index.toString();
                    return title;
                }
            },
            validateState(v) {
                if (!v.$dirty) {
                    return null;
                } else {
                    return (v.$error) ? false : true
                }
            }
        }
    }
</script>